const signedScore = new Intl.NumberFormat('en', { signDisplay: 'exceptZero', useGrouping: false });

export const formatSignedScore = (score: number): string => signedScore.format(score);
